import { CHAT_STICKERS, QUICK_CHAT_PHRASES, stickerAnimationClass } from 'constants/game';

interface TableChatPickerProps {
  onSendPhrase: (phraseId: string) => void;
  onSendSticker: (stickerId: string) => void;
  onSent?: () => void;
  compact?: boolean;
}

/** Quick phrases + emoji only — tap to send (used in hero chat popover). */
export default function TableChatPicker({
  onSendPhrase,
  onSendSticker,
  onSent,
  compact = true,
}: TableChatPickerProps) {
  const phraseCount = compact ? 4 : QUICK_CHAT_PHRASES.length;

  const handlePhrase = (phraseId: string) => {
    onSendPhrase(phraseId);
    onSent?.();
  };

  const handleSticker = (stickerId: string) => {
    onSendSticker(stickerId);
    onSent?.();
  };

  return (
    <div className={`tp-table-chat-picker ${compact ? 'tp-table-chat-picker-compact' : ''}`}>
      <div className="tp-table-chat-picker-phrases">
        {QUICK_CHAT_PHRASES.slice(0, phraseCount).map((phrase) => (
          <button
            key={phrase.id}
            type="button"
            className="tp-table-chat-picker-phrase"
            onClick={() => handlePhrase(phrase.id)}
          >
            {phrase.label}
          </button>
        ))}
      </div>
      <div className="tp-table-chat-picker-stickers" aria-label="Emoji stickers">
        {CHAT_STICKERS.map((sticker) => (
          <button
            key={sticker.id}
            type="button"
            className="tp-table-chat-picker-sticker"
            title={sticker.label}
            aria-label={sticker.label}
            onClick={() => handleSticker(sticker.id)}
          >
            <span className={stickerAnimationClass(sticker.id)} aria-hidden="true">
              {sticker.emoji}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
